import moment from 'moment';

export const formatDate = (date, dateFormat = 'DD MMM YYYY') => {
    if (!date || !moment(date).isValid()) {
        return "N/A";
    }

    return moment(date).format(dateFormat);
};
